import StyleSheet from 'react-native-extended-stylesheet';

export const style = StyleSheet.create({
  container: {
    backgroundColor: '$colorBgSurface',
    borderRadius: 8,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: '$space4',
  },
});
